import Image from "./Image";



export default function Logo() {
    return <Image name="static/logo.png" alt="ArtCourtens" />
}